import { css } from '@emotion/core';
import brownPattern from '../../images/brownPattern.png';

export const backgroundStyle = theme => css`
  background-color: ${ theme.colors.brownLight };
  background-image: url("${ brownPattern }");
`;
